class ErrorMessage {
    public Code: string;
    public Message: string;
    public Type: string;
    public VocabularyKey: string;

    constructor(fields: Partial<ErrorMessage> = null) {
        if (fields) {
            (<any>Object).assign(this, fields);
        }
    }
}

export { ErrorMessage };
